import { makeStyles } from 'tss-react/mui';

export const useLeaveOfflineModeButtonStyles = makeStyles()((theme) => ({
  button: {
    color: theme.palette.text.secondary,
    '&:hover': {
      backgroundColor: theme.palette.custom.layout.shell.buttonHover,
    },
  },
  buttonCollapsed: {
    justifyContent: 'center',
  },
  icon: {
    color: 'inherit',
    marginRight: theme.spacing(1),
  },
}));
